import HTTP from "../../http";

const EMAIL_ENDPOINT = "/email";
const VERIFY_PASSWORD_TOKEN_ENDPOINT = "/verifyPasswordToken";

export async function verifyPasswordToken(token) {
  // console.log(token);
  return await HTTP.post(
    EMAIL_ENDPOINT + VERIFY_PASSWORD_TOKEN_ENDPOINT,
    { token: token },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
